<template lang="html">
  <div class="title-bar">
    <div class="back-button">
      <button
        class="menu-button"
        @click="backButtonHandler"
        v-if="current != 'Introduction'"
      >
        <svg
          viewBox="0 0 8 13"
          width="100%"
          height="100%"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fill-rule="evenodd">
            <path
              fill="#000"
              d="M6.5 12.864L.136 6.5 1.55 5.086l6.364 6.364z"
            />
            <path fill="#000" d="M.136 6.5L6.5.136 7.914 1.55 1.55 7.914z" />
            <path d="M-4-3h18v18H-4z" />
          </g>
        </svg>
      </button>
    </div>

    <h1 class="title-bar__title">
      {{ current }}
    </h1>

    <button class="menu-button" v-on:click="handleNavToggle">
      <svg
        viewBox="0 0 14 16"
        data-v-3f68fd4b=""
        xmlns="http://www.w3.org/2000/svg"
        class="menu-button__icon"
        width="100%"
        height="100%"
      >
        <g data-v-3f68fd4b="" fill="none" fill-rule="evenodd">
          <path
            data-v-3f68fd4b=""
            fill="#000"
            d="M0 0h16v2H0zM0 6h16v2H0zM0 12h16v2H0z"
          ></path>
          <path data-v-3f68fd4b="" d="M-1-2h18v18H-1z"></path>
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    current: function() {
      if (this.$route.path === "/") {
        return "Introduction";
      } else if (this.$route.path === "/stops") {
        return "Stops";
      } else if (this.$route.path === "/info") {
        return "Information";
      } else if (this.$route.path === "/map") {
        return "Exhibition Map";
      } else {
        // else route is single stop:
        return "Stop " + this.$route.params.id;
      }
    },
    ...mapState(["navOpen", "currentStop"])
  },
  methods: {
    backButtonHandler: function() {
      if (this.$route.name !== "stop") {
        this.$router.go(-1);
      } else {
        this.$router.push("/stops");
      }
    },
    handleNavToggle() {
      this.$store.dispatch("toggleNavigation");
    }
  }
};
</script>

<style lang="scss" scoped>
.title-bar {
  position: fixed;
  top: 0;
  z-index: 100;

  width: 100%;
  height: 40px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 1em;
  border: 1px solid #efefef;
  background-color: white;
  @include ngv-type($exhibition_subtitle, 12px, 14px);
}
.title-bar__title {
  font-size: 1.1em;
}
.menu-button {
  border: none;
  background: none;
  cursor: pointer;

  &__icon {
    display: block;
    width: 18px;
  }
}
.back-button {
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 12px;
  }
}
</style>
